export default __webpack_public_path__ + "static/media/elipse-fill.5c449d98.svg";